export default {
    import_account_label: 'Account',
    import_account_imported_on: 'Imported On',
    import_account_updated_on: 'Updated On',
    import_account_contacts: 'Contacts',
    import_account_alerts: 'Alerts',
    import_account_categories: 'Categories',
    import_account_behavior: 'Behavior',
    import_account_users: 'Users',
    import_account_drivers: 'Drivers',
    import_account_devices: 'Devices',
    import_account_geofences: 'Geofences',
    import_account_maintenance: 'Maintenance',
    import_account_exceptions: 'Exceptions',
    import_account_title: 'Import P4',
    import_account_import_account: 'Import Account',
    import_account_external_id: 'External Id',
    import_account_speed_override: 'Speed Override',
};